<div class="iframe-container">
  <iframe
    [title]="content().iframeUrl | safeUrl"
    [class.border-hidden]="hasBorderHidden()"
    [src]="content().iframeUrl | safeUrl"
    [height]="height()"
    [width]="content().widthDesktop">
  </iframe>
</div>
